import React from 'react';
import { Link } from 'react-router-dom';

import { patientEpisodePath } from '../../utils/navigation';

interface BillingPeriodCellProps {
  patientId?: string | null;
  episodeId?: string | null;
  startDate: string;
  endDate: string;
}

const BillingPeriodCell: React.FC<BillingPeriodCellProps> = ({
  patientId,
  episodeId,
  startDate,
  endDate,
}) => {
  const periodText = (
    <>
      <span>{startDate} -</span>
      <br />
      <span>{endDate}</span>
    </>
  );

  if (!patientId || !episodeId) {
    return <>{periodText}</>;
  }

  return (
    <Link
      to={patientEpisodePath(patientId, episodeId)}
      className='text-primary underline-offset-4 hover:underline'
    >
      {periodText}
    </Link>
  );
};

export default BillingPeriodCell;
